import { WS_METHODS } from "@cmmd-forge/contracts";

import type { RpcUnaryMethod } from "./rpcClientTypes";
import { type WsTransport } from "./wsTransport";

export interface WsRpcWorkspace {
  readonly environmentPreflight: RpcUnaryMethod<typeof WS_METHODS.workspaceEnvironmentPreflight>;
  /** One directory's immediate children, for the Files tree. */
  readonly listDirectory: RpcUnaryMethod<typeof WS_METHODS.workspaceListDirectory>;
  readonly ensureScratch: RpcUnaryMethod<typeof WS_METHODS.workspaceEnsureScratch>;
}

export function createWsRpcWorkspace(transport: WsTransport): WsRpcWorkspace {
  return {
    environmentPreflight: (input) =>
      transport.request((client) => client[WS_METHODS.workspaceEnvironmentPreflight](input)),
    listDirectory: (input) =>
      transport.request((client) => client[WS_METHODS.workspaceListDirectory](input)),
    ensureScratch: (input) =>
      transport.request((client) => client[WS_METHODS.workspaceEnsureScratch](input)),
  };
}
